import KeenSlider from "keen-slider"

export default () => {
    const nodeSelectors = {
        slider: '[js-slider="slider"]',
        nextBtn: '[js-slider="slider-next-btn"]',
        prevBtn: '[js-slider="slider-prev-btn"]',
    }

    function init() {
        if (!document.querySelector(nodeSelectors.slider)) {
            return
        }

        initSlider()
    }

    function initSlider() {

    }

    return Object.freeze({
        init,
    })
}